"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DropdownOption_st_css_1 = require("./DropdownOption.st.css");
exports.DropdownOption = function (props) {
    var id = props.id, option = props.option, isSelected = props.isSelected, isHovered = props.isHovered, onClickHandler = props.onClickHandler, onMouseEnterHandler = props.onMouseEnterHandler, dataHook = props.dataHook;
    var disabled = option.isDisabled;
    var selectable = option.isSelectable;
    var hovered = !disabled && isHovered;
    var selected = !disabled && isSelected;
    var ariaProps = selectable
        ? { role: 'option', 'aria-selected': selected, 'aria-disabled': disabled }
        : {};
    return (React.createElement("div", tslib_1.__assign({ id: id, className: DropdownOption_st_css_1.st(DropdownOption_st_css_1.classes.root, { disabled: disabled, selectable: selectable, hovered: hovered, selected: selected }, props.className), "data-hook": dataHook }, ariaProps, { onClick: onClickHandler, title: option.value, onMouseEnter: onMouseEnterHandler }), option.render(option.value)));
};
exports.DropdownOption.displayName = 'DropdownOption';
//# sourceMappingURL=DropdownOption.js.map